"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StatsWidgetHeader = _interopRequireDefault(require("./StatsWidgetHeader"));

var _StatsWidgetBody = _interopRequireDefault(require("./StatsWidgetBody"));

var _StatsWidgetFooter = _interopRequireDefault(require("./StatsWidgetFooter"));

var _excluded = ["children", "hasFilter", "onFilterReset", "className"];

var StatsWidget = function StatsWidget(props) {
  var children = props.children,
      hasFilter = props.hasFilter,
      onFilterReset = props.onFilterReset,
      className = props.className,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var resetFilterButtonClassNames = (0, _classnames.default)('bg-light hover-bg-highlight', 'display-flex justify-content-center align-items-center', 'padding-2', 'rounded-circle', 'position-absolute top-15 right-15', 'display-block', 'height-20 width-20', 'cursor-pointer');
  var wrapperClasses = (0, _classnames.default)('StatsWidget', className && className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: wrapperClasses
  }), hasFilter && /*#__PURE__*/_react.default.createElement("span", {
    className: resetFilterButtonClassNames,
    onClick: onFilterReset
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-revert text-color-white text-size-12'
  })), children);
};

StatsWidget.Header = _StatsWidgetHeader.default;
StatsWidget.Body = _StatsWidgetBody.default;
StatsWidget.Footer = _StatsWidgetFooter.default;
StatsWidget.defaultProps = {
  hasFilter: false,
  onFilterReset: function onFilterReset() {}
};
StatsWidget.propTypes = {
  hasFilter: _propTypes.default.bool,
  onFilterReset: _propTypes.default.func,
  className: _propTypes.default.string
};
var _default = StatsWidget;
exports.default = _default;